<template>
  <span
    v-if="!shouldHideLabel"
    class="flex items-center gap-1.5"
  >
    <span class="ais-CurrentRefinements-categoryLabel">
      {{ currentRefinementLabel }}
    </span>
    <button
      :aria-label="$t('Remove filter')"
      @click.prevent="onClick"
    >
      <span class="iconify svg--close text-EXPONDO-primary-10 rounded-full text-xs" />
    </button>
  </span>
</template>

<script lang="ts">

import type { CurrentRefinementItem } from 'vue-instantsearch/vue3/es';
import { TYPESENSE_ATTRIBUTE, MAX_STARS } from '~~/constants/typesense';

import { EVENT_SOURCE } from '~~/constants/googleTagManager';

export default defineComponent({
  name: 'CurrentRefinementLabel',
  props: {
    refinement: {
      type: Object as PropType<CurrentRefinementItem>,
      required: true,
    },
    createUrl: {
      type: Function as PropType<(refinement: CurrentRefinementItem) => string>,
      required: true,
    },
  },
  emits: ['refine'],
  setup(props, { emit }) {

    const { getTypesenseFilterName } = useTypesense();
    const route = useRoute();
    const { trackClearSingleFilter } = useGtmEvents();
    const { getCurrentPageType } = usePageEventLocation();
    const {
      getters: {
        currentCategoryName,
      },
    } = useCategories();
    const pageType = getCurrentPageType();
    const categoryPath = pageType === EVENT_SOURCE.CATEGORY_LISTING ? route.params.slug : '';
    const categoryName = pageType === EVENT_SOURCE.CATEGORY_LISTING ? currentCategoryName.value : '';

    const currentRefinementLabel = computed(() =>
      getTypesenseFilterName(props.refinement.label, props.refinement.attribute),
    );

    const refinementUrl = computed(() => props.createUrl(props.refinement));

    const shouldHideLabel = computed(() =>
      props.refinement.attribute === TYPESENSE_ATTRIBUTE.AVG_RATING &&
      props.refinement.value === MAX_STARS,
    );

    const onClick = () => {

      emit('refine', props.refinement);
      trackClearSingleFilter({
        filterName: props.refinement.label,
        filterValue: props.refinement.value,
        categoryPath,
        categoryName,
        listingType: pageType,
      });

    };

    return {
      currentRefinementLabel,
      refinementUrl,
      shouldHideLabel,
      onClick,
    };

  },
});

</script>
